__turbopack_context__.v({
  "loader": "Loader-module__HBVWzW__loader",
  "loaderCopy1": "Loader-module__HBVWzW__loaderCopy1",
  "loaderCopy2": "Loader-module__HBVWzW__loaderCopy2",
  "loaderCopy3": "Loader-module__HBVWzW__loaderCopy3",
  "progressBar": "Loader-module__HBVWzW__progressBar",
  "word": "Loader-module__HBVWzW__word",
});
